import React, { useState } from "react";
import { CometChat } from "@cometchat-pro/chat";

// mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

type SendInputProps = {
  guid: string;
  handleMsgSent: (msg: CometChat.TextMessage | CometChat.MediaMessage | CometChat.CustomMessage | CometChat.BaseMessage) => void;
};
const SendInput: React.FC<SendInputProps> = (props) => {
  const { guid, handleMsgSent } = props;

  const [msg, setMsg] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMsg(event.target.value);
  };

  // const fileUploadRef = useRef<HTMLInputElement | null>(null);

  const sendTextMsg = () => {
    const receiverID = guid;
    const receiverType = CometChat.RECEIVER_TYPE.GROUP;
    const textMessage = new CometChat.TextMessage(receiverID, msg, receiverType);
    CometChat.sendMessage(textMessage).then(
      (message) => {
        console.log("Message sent successfully:", message);
        handleMsgSent(message); // callback
        setMsg(""); // reset
      },
      (error) => {
        console.log("Message sending failed with error:", error);
      },
    );
  };

  // 画像とfileのみ対応(audioやvideloもcometchatは対応してる)
  // const sendMediaMsg = (file: File) => {
  //   const receiverID = guid;
  //   const receiverType = CometChat.RECEIVER_TYPE.GROUP;
  //   let messageType = "";
  //   if (file.type.startsWith("image")) {
  //     messageType = CometChat.MESSAGE_TYPE.IMAGE;
  //   } else {
  //     messageType = CometChat.MESSAGE_TYPE.FILE;
  //   }
  //   const mediaMessage = new CometChat.MediaMessage(receiverID, file, messageType, receiverType);
  //   CometChat.sendMediaMessage(mediaMessage).then(
  //     (message) => {
  //       handleMsgSent(message);
  //     },
  //     (error: any) => {
  //       console.log("send media failed", error);
  //     },
  //   );
  // };

  // const handleOpenUpload = () => {
  //   if (fileUploadRef?.current) {
  //     fileUploadRef.current.click();
  //   }
  // };

  // const handleFilesChange = () => {
  //   console.log("files to upload");
  //   const files = fileUploadRef?.current?.files;
  //   if (!files) {
  //     return;
  //   }
  //   for (let i = 0; i < files.length; ++i) {
  //     const file = files[i];
  //     const reader = new FileReader();
  //     reader.onabort = () => console.log("file reading was aborted");
  //     reader.onerror = () => console.log("file reading has failed");
  //     reader.onload = () => {
  //       const result = reader.result;
  //       if (result) {
  //         const newFile = new File([result], file.name, file);
  //         sendMediaMsg(newFile);
  //       }
  //     };
  //     reader.readAsArrayBuffer(file);
  //   }
  // };

  const handleKeyboard = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // cmd + Enter もしくは ctrl + Enter
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      sendTextMsg();
    }
  };

  return (
    <Box>
      <TextField
        size="small"
        fullWidth
        multiline
        maxRows={4}
        autoFocus
        placeholder="Cmd+Enter/Ctrl+Enter to send"
        value={msg}
        onChange={handleChange}
        onKeyDown={handleKeyboard}
      />
      <Stack direction="row" justifyContent="flex-end">
        {/*
          添付されるファイルのリンクに対して認証を噛ませてからコメントイン by 大塚
          https://github.com/Nitoel/nitoel/issues/594
          <IconButton onClick={handleOpenUpload} size="small">
            <AddCircleOutlineIcon />
            <input hidden type="file" ref={fileUploadRef} onChange={handleFilesChange} />
          </IconButton>
        */}
        <IconButton onClick={sendTextMsg} size="small">
          <SendIcon />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default SendInput;
